/*
 * vg-cookie-banner.js — Victoria's Gala
 * Lightweight GDPR-style consent UI with Shopify Customer Privacy sync.
 */
(function () {
  'use strict';

  var KEY = 'vg_cookie_consent';
  var DAYS = 365;

  function readConsent() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (d.expires && Date.now() > d.expires) return null;
      return d;
    } catch (e) { return null; }
  }

  function saveConsent(consent) {
    var data = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      expires: Date.now() + DAYS * 86400000,
      timestamp: Date.now()
    };
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}

    // Also store as cookie for server-side awareness (limited)
    try {
      var maxAge = DAYS * 86400;
      document.cookie = KEY + '=' + (data.analytics ? '1' : '0') + (data.marketing ? '1' : '0') +
        '; max-age=' + maxAge + '; path=/; SameSite=Lax';
    } catch (e) {}

    // Sync to Shopify Customer Privacy
    syncShopify(data);
  }

  function syncShopify(consent) {
    function apply() {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: true,
          sale_of_data: false
        }, function (result) {
          if (result && result.error) {
            console.warn('[vg-cookie] setTrackingConsent devolvió un error:', result.error);
          }
        });
      } catch (e) {
        console.warn('[vg-cookie] setTrackingConsent falló:', e);
      }
    }
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
      apply();
      return;
    }
    // Mecanismo oficial: cargar la Customer Privacy API bajo demanda.
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) {
          console.warn('[vg-cookie] No se pudo cargar consent-tracking-api:', error);
          return;
        }
        apply();
      });
    } else {
      console.warn('[vg-cookie] La API de privacidad de Shopify no está disponible en esta página.');
    }
  }

  function showBanner() {
    var b = document.getElementById('vg-cookie-banner');
    if (!b) return;
    b.hidden = false;
    document.body.classList.add('vg-cookie-open');
    requestAnimationFrame(function () { b.classList.add('is-visible'); });
  }

  function hideBanner() {
    var b = document.getElementById('vg-cookie-banner');
    if (!b) return;
    b.classList.remove('is-visible');
    document.body.classList.remove('vg-cookie-open');
    setTimeout(function () { b.hidden = true; }, 300);
  }

  function openPrefs() {
    var dlg = document.getElementById('vg-cookie-prefs');
    if (!dlg) return;
    // Pre-fill checkboxes with current consent if any
    var existing = readConsent();
    var aBox = dlg.querySelector('[data-vg-cat="analytics"]');
    var mBox = dlg.querySelector('[data-vg-cat="marketing"]');
    if (aBox) aBox.checked = existing ? !!existing.analytics : false;
    if (mBox) mBox.checked = existing ? !!existing.marketing : false;

    if (typeof dlg.showModal === 'function') {
      try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
    } else {
      dlg.setAttribute('open', '');
    }
  }

  function closePrefs() {
    var dlg = document.getElementById('vg-cookie-prefs');
    if (!dlg) return;
    if (typeof dlg.close === 'function') {
      try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); }
    } else {
      dlg.removeAttribute('open');
    }
  }

  function placeReopenLink() {
    // Preferencia de dirección: enlace reconocible en el pie, no una burbuja fija.
    var reopen = document.querySelector('.vg-cookie-reopen');
    if (!reopen) return;
    var target = document.querySelector('footer .vg-cookie-reopen-slot') ||
      document.querySelector('footer [data-testid="footer-utilities"]') ||
      document.querySelector('footer .utilities') ||
      document.querySelector('footer');
    if (target) {
      reopen.classList.add('vg-cookie-reopen--footer');
      target.appendChild(reopen);
    }
    reopen.hidden = false;
  }

  function init() {
    placeReopenLink();
    var existing = readConsent();
    if (existing) {
      syncShopify(existing);
    } else {
      showBanner();
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-vg-cookie]');
      if (!t) return;
      var a = t.getAttribute('data-vg-cookie');

      if (a === 'accept') {
        saveConsent({ analytics: true, marketing: true });
        hideBanner();
      } else if (a === 'reject') {
        saveConsent({ analytics: false, marketing: false });
        hideBanner();
      } else if (a === 'manage') {
        openPrefs();
      } else if (a === 'close-prefs') {
        closePrefs();
      } else if (a === 'reject-all') {
        saveConsent({ analytics: false, marketing: false });
        closePrefs();
        hideBanner();
      } else if (a === 'save-prefs') {
        var aBox = document.querySelector('[data-vg-cat="analytics"]');
        var mBox = document.querySelector('[data-vg-cat="marketing"]');
        saveConsent({
          analytics: aBox ? aBox.checked : false,
          marketing: mBox ? mBox.checked : false
        });
        closePrefs();
        hideBanner();
      } else if (a === 'reopen') {
        openPrefs();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
